import { Typography } from '@mui/material';
import { useAppDispatch } from '../../../pages/assessment';
import {
  AssessmentButtons,
  AssessmentCard,
  AssessmentCrisisAlert,
} from '../shared';
import { updateMeta } from '../../../redux/meta';

const GetStarted = () => {
  const dispatch = useAppDispatch();
  const onClick = async () => dispatch(updateMeta());

  return (
    <>
      <AssessmentCard>
        <Typography>
          We’re about to match you with one of our psychiatrists. But first
          we’ll need to know a bit more about you. We can only accept patients
          with insurance. This will take about 5-10 minutes.
        </Typography>
        <AssessmentCrisisAlert />
      </AssessmentCard>
      <AssessmentButtons
        primary={{
          children: 'Get started',
          onClick,
        }}
      />
    </>
  );
};

export default GetStarted;
